module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "desktop",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    staticClass: "subscribe ag bold h-xl",
    class: {
      grey: _vm.whiteFooter
    },
    attrs: {
      "aria-label": "open newsletter subscribe modal"
    },
    on: {
      "click": function($event) {
        _vm.subscribe = true
      }
    }
  }, [_vm._v("join our newsletter")]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Facebook Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.facebook,
      "alt": "facebook icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://twitter.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Twitter Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.twitter,
      "alt": "twitter icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/caaminla/",
      "target": "_blank",
      "aria-label": "Link to CAAM Instagram Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.insta,
      "alt": "instagram icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg",
      "target": "_blank",
      "aria-label": "Link to CAAM Youtube Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.youtube,
      "alt": "youtube icon"
    }
  })])])]), _vm._m(0)]), _c('div', {
    staticClass: "col-9",
    class: {
      grey: _vm.subscribe
    }
  }, [(!_vm.subscribe) ? _c('div', {
    staticClass: "grid nav no-margin"
  }, _vm._l((_vm.mapRoot()), function(items) {
    return _c('div', {
      staticClass: "col-4"
    }, [_c('ul', _vm._l((items), function(item) {
      return _c('li', [_c('router-link', {
        attrs: {
          "to": {
            name: item.uid
          }
        }
      }, [_c('h3', {
        staticClass: "h-l"
      }, [_vm._v(_vm._s(item.title))])]), _c('ul', {
        attrs: {
          "id": "subnav"
        }
      }, _vm._l((item.children), function(child) {
        return _c('li', [((item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')) ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ("" + (item.uid)),
              query: {
                status: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'programs') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-overview"),
              params: {
                category: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'learn' && child.uid === '600state') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: 'blog'
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : (item.uid === 'learn' && child.uid !== '600state') ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid !== 'subscribe')) ? _c('router-link', {
          staticClass: "h-sx",
          attrs: {
            "to": {
              name: ((item.uid) + "-page"),
              params: {
                id: _vm.formatRoute(child.uid)
              }
            }
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid === 'subscribe')) ? _c('p', {
          staticClass: "h-sx",
          on: {
            "click": _vm.subs
          }
        }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e()], 1)
      }))], 1)
    }))])
  })) : _vm._e(), (_vm.subscribe) ? _c('div', {
    staticClass: "newsletter"
  }, [(!_vm.message) ? _c('form', [_c('fieldset', [_c('legend', {
    staticClass: "dn"
  }, [_vm._v("Subscribe to Newsletter")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "email",
      "name": "email",
      "title": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first),
      expression: "first"
    }],
    attrs: {
      "type": "text",
      "placeholder": "first name",
      "name": "firstname",
      "title": "First Name"
    },
    domProps: {
      "value": (_vm.first)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first = $event.target.value
      }
    }
  }), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last),
      expression: "last"
    }],
    attrs: {
      "type": "text",
      "placeholder": "last name",
      "name": "lastname",
      "title": "Last Name"
    },
    domProps: {
      "value": (_vm.last)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('zip')
    },
    attrs: {
      "type": "text",
      "placeholder": "zip code",
      "name": "zip",
      "title": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Subscribe to Newsletter"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("subscribe!")])])]) : _vm._e(), (_vm.message) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _c('div', {
    staticClass: "x",
    on: {
      "click": _vm.xOut
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg",
      "alt": "exit newsletter signup"
    }
  })], 1)]) : _vm._e()])]), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [(!_vm.whiteFooter) ? _c('div', {
    attrs: {
      "id": "logo-bottom"
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo_white.svg",
      "alt": "Caam Logo"
    }
  })], 1) : _vm._e(), (_vm.whiteFooter) ? _c('div', {
    attrs: {
      "id": "logo-bottom"
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo.svg",
      "alt": "Caam Logo"
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    attrs: {
      "id": "slogan-bottom"
    }
  }, [(!_vm.subscribe) ? _c('h4', {
    staticClass: "free h-l lh-8",
    class: {
      white: _vm.whiteFooter
    }
  }, [_vm._v("art. history. culture.")]) : _vm._e()])])])]), _c('div', {
    staticClass: "mobile",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('button', {
    staticClass: "subscribe ag bold h-xl",
    class: {
      grey: _vm.whiteFooter
    },
    attrs: {
      "aria-label": "open newsletter subscribe modal"
    },
    on: {
      "click": function($event) {
        _vm.subscribe = true
      }
    }
  }, [_vm._v("join our newsletter")]), (_vm.subscribe) ? _c('div', {
    staticClass: "newsletter grey"
  }, [(!_vm.message) ? _c('form', [_c('fieldset', [_c('legend', {
    staticClass: "dn"
  }, [_vm._v("Subscribe to Newsletter")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "email",
      "name": "email",
      "title": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))]), _c('label', {
    staticClass: "dn",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('zip')
    },
    attrs: {
      "type": "text",
      "placeholder": "zip code",
      "name": "zip",
      "title": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Subscribe to Newsletter"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("subscribe!")]), (_vm.message) ? _c('div', {
    staticClass: "message"
  }, [_c('h2', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _c('div', {
    staticClass: "x",
    on: {
      "click": _vm.xOut
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/x_out.svg",
      "alt": "exit newsletter signup"
    }
  })], 1)])]) : _vm._e()]) : _vm._e(), _c('p', {
    staticClass: "hours body",
    class: {
      white: _vm.whiteFooter
    }
  }, [_c('strong', [_vm._v("Hours ")]), _c('br'), _vm._v("\nGalleries Open "), _c('br'), _vm._v("\nTuesdays-Saturdays 10:00 a.m.-5:00 p.m. "), _c('br'), _vm._v("\nSundays 11:00 a.m.-5:00 p.m.")]), _vm._m(1), _c('p', {
    staticClass: "address body"
  }, [_vm._v("600 State Drive, Exposition Park, Los Angeles, CA 90037")]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Facebook Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.facebook,
      "alt": "facebook icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://twitter.com/caaminla",
      "target": "_blank",
      "aria-label": "Link to CAAM Twitter Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.twitter,
      "alt": "twitter icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/caaminla/",
      "target": "_blank",
      "aria-label": "Link to CAAM Instagram Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.insta,
      "alt": "instagram icon"
    }
  })])]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCxbgXMDaQPRWeBxTd85HtFg",
      "target": "_blank",
      "aria-label": "Link to CAAM Youtube Page"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.youtube,
      "alt": "youtube icon"
    }
  })])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hours body"
  }, [_c('strong', [_vm._v(" Hours ")]), _vm._v(" "), _c('br'), _vm._v("\nGalleries Open "), _c('br'), _vm._v("\nTuesdays-Saturdays "), _c('br'), _vm._v("\n10:00 a.m.-5:00 p.m. "), _c('br'), _vm._v("\nSundays "), _c('br'), _vm._v("\n11:00 a.m.-5:00p.m.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h-xxl lh-8"
  }, [_vm._v("California "), _c('br'), _vm._v("\nAfrican American "), _c('br'), _vm._v("\nMuseum")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1cdeba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomNav.vue
// module id = 235
// module chunks = 1